export default {
  authorUrlPattern: /^https:\/\/www.kinopoisk.ru\/user\/([0-9]+)\/?$/,
  mainAuthorUrlPart: 'https://www.kinopoisk.ru/user/'
};



// WEBPACK FOOTER //
// ./src/config/kinopoisk.js